(()=>{
  if(window.__hiknightEbikeCollectionV2Bound)return;
  window.__hiknightEbikeCollectionV2Bound=true;

  let selectedCategory='all';
  const selectedPowers=new Set();
  let filterTimer=0;
  let klarnaTimer=0;

  const root=()=>document.querySelector('.hk-ebike-collection');
  const cards=()=>[...(root()?.querySelectorAll('.hk-ebike-grid__item[data-hk-category]')||[])];

  const cardFrom=(node)=>node?.closest?.('.hk-ebike-collection [data-epc-card]');

  const refreshKlarna=()=>{
    clearTimeout(klarnaTimer);
    klarnaTimer=setTimeout(()=>{
      try{ window.Klarna?.OnsiteMessaging?.refresh?.(); }catch(_){}
    },90);
  };

  const matchesPower=(card)=>{
    if(selectedPowers.size===0)return true;
    return selectedPowers.has((card.dataset.hkPower||'').trim());
  };

  const matchesCategory=(card)=>{
    if(selectedCategory==='all')return true;
    return (card.dataset.hkCategory||'')===selectedCategory;
  };

  const updateCategoryUI=(allCards)=>{
    const countByCategory={dirt:0,'off-road':0,'fat-tire':0,combo:0};

    allCards.forEach(card=>{
      if(!matchesPower(card))return;
      const key=card.dataset.hkCategory||'';
      if(key in countByCategory)countByCategory[key]++;
    });

    document.querySelectorAll('.hk-ebike-collection [data-hk-category-option]').forEach(btn=>{
      const key=btn.dataset.hkCategoryOption;
      const count=countByCategory[key]||0;
      btn.classList.toggle('is-active',selectedCategory===key);
      btn.setAttribute('aria-pressed',selectedCategory===key?'true':'false');
      btn.disabled=count===0 && selectedCategory!==key;

      document.querySelectorAll(`.hk-ebike-collection [data-hk-category-count="${CSS.escape(key)}"]`).forEach(countEl=>{
        countEl.textContent=`(${count})`;
      });
    });

    const isAll=selectedCategory==='all';
    document.querySelectorAll('.hk-ebike-collection [data-hk-category-all]').forEach(allBtn=>{
      allBtn.classList.toggle('is-active',isAll);
      allBtn.setAttribute('aria-pressed',isAll?'true':'false');
    });
  };

  const updatePowerUI=(allCards)=>{
    ['2000W','4000W','5000W'].forEach(power=>{
      let count=0;
      allCards.forEach(card=>{
        if(!matchesCategory(card))return;
        if((card.dataset.hkPower||'').trim()===power)count++;
      });

      document.querySelectorAll(`.hk-ebike-collection [data-hk-power-row="${power}"]`).forEach(row=>{
        const input=row.querySelector('[data-hk-power-option]');
        if(input)input.checked=selectedPowers.has(power);
        row.classList.toggle('is-disabled',count===0 && !selectedPowers.has(power));
      });
      document.querySelectorAll(`.hk-ebike-collection [data-hk-power-count="${power}"]`).forEach(countEl=>{
        countEl.textContent=`(${count})`;
      });
    });
  };

  const applyClientFilters=()=>{
    const pageRoot=root();
    if(!pageRoot)return;

    const allCards=cards();
    let visible=0;

    allCards.forEach(card=>{
      const show=matchesCategory(card)&&matchesPower(card);
      card.hidden=!show;
      if(show)visible++;
    });

    let empty=pageRoot.querySelector('[data-hk-power-empty]');
    if(empty){
      empty.classList.add('hk-ebike-filter-empty');
      empty.textContent='No products match these filters.';
      empty.hidden=visible!==0;
    }

    const count=pageRoot.querySelector('#ProductCount');
    if(count)count.textContent=`${visible} ${visible===1?'product':'products'}`;

    updateCategoryUI(allCards);
    updatePowerUI(allCards);
  };

  const scheduleFilters=()=>{
    clearTimeout(filterTimer);
    filterTimer=setTimeout(applyClientFilters,50);
  };

  // CATEGORY: no navigation. One category can be active at a time.
  document.addEventListener('click',(event)=>{
    const category=event.target.closest?.('.hk-ebike-collection [data-hk-category-option]');
    if(category){
      event.preventDefault();
      if(category.disabled)return;
      const value=category.dataset.hkCategoryOption;
      selectedCategory=(selectedCategory===value)?'all':value;
      applyClientFilters();
      return;
    }

    const showAll=event.target.closest?.('.hk-ebike-collection [data-hk-category-all]');
    if(showAll){
      event.preventDefault();
      selectedCategory='all';
      applyClientFilters();
      return;
    }

    // Homepage card color swatches reused on this collection.
    const swatch=event.target.closest?.('.hk-ebike-collection [data-epc-swatch]');
    if(!swatch)return;

    const card=cardFrom(swatch);
    if(!card)return;

    card.querySelectorAll('[data-epc-swatch]').forEach(el=>el.classList.toggle('is-active',el===swatch));

    const colorLabel=card.querySelector('[data-epc-color-label]');
    if(colorLabel&&swatch.dataset.colorName)colorLabel.textContent=swatch.dataset.colorName;

    const img=card.querySelector('.epc-card__image--primary');
    if(img&&swatch.dataset.imageUrl){
      img.src=swatch.dataset.imageUrl;
      img.removeAttribute('srcset');
    }

    const input=card.querySelector('[data-epc-variant-input]');
    if(input&&swatch.dataset.variantId)input.value=swatch.dataset.variantId;

    const productLink=card.querySelector('[data-epc-product-link]');
    const viewLink=card.querySelector('[data-epc-view-link]');
    if(swatch.dataset.variantUrl){
      if(productLink)productLink.href=swatch.dataset.variantUrl;
      if(viewLink)viewLink.href=swatch.dataset.variantUrl;
    }

    const price=card.querySelector('[data-epc-price]');
    if(price&&swatch.dataset.price)price.textContent=swatch.dataset.price;

    const compare=card.querySelector('[data-epc-compare-price]');
    if(compare){
      compare.textContent=swatch.dataset.comparePrice||'';
      compare.classList.toggle('is-hidden',!swatch.dataset.comparePrice);
    }

    const sale=card.querySelector('[data-epc-sale-badge]');
    if(sale){
      sale.textContent=swatch.dataset.save?`${swatch.dataset.save} OFF`:'';
      sale.hidden=!swatch.dataset.save;
    }

    const klarna=card.querySelector('[data-epc-klarna-placement]');
    if(klarna&&swatch.dataset.priceAmount){
      klarna.setAttribute('data-purchase-amount',swatch.dataset.priceAmount);
      refreshKlarna();
    }
  });

  // POWER: can combine 2000W + 4000W.
  document.addEventListener('change',(event)=>{
    const power=event.target.closest?.('.hk-ebike-collection [data-hk-power-option]');
    if(power){
      if(power.checked)selectedPowers.add(power.value);
      else selectedPowers.delete(power.value);
      applyClientFilters();
      return;
    }

    // Simple sort UI drives the theme's existing AJAX facet form.
    const sort=event.target.closest?.('.hk-ebike-collection [data-hk-ebike-sort]');
    if(sort){
      const pageRoot=root();
      const form=pageRoot?.querySelector('form.facet-form');
      if(!form){
        const url=new URL(location.href);
        url.searchParams.set('sort_by',sort.value);
        location.assign(url.toString());
        return;
      }

      let hidden=form.querySelector('input[name="sort_by"]');
      if(!hidden){
        hidden=document.createElement('input');
        hidden.type='hidden';
        hidden.name='sort_by';
        form.appendChild(hidden);
      }
      hidden.value=sort.value;
      hidden.dispatchEvent(new Event('change',{bubbles:true}));
    }
  });

  // The theme replaces ProductGridContainer after native Availability/Price/sort AJAX.
  // Reapply our client-side category + power state after every replacement.
  const observe=()=>{
    const pageRoot=root();
    if(!pageRoot||!('MutationObserver'in window))return;
    new MutationObserver(scheduleFilters).observe(pageRoot,{childList:true,subtree:true});
  };

  document.addEventListener('collection:reloaded',scheduleFilters);
  document.addEventListener('shopify:section:load',scheduleFilters);

  observe();
  requestAnimationFrame(applyClientFilters);
})();